import React, { useRef, useEffect } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import { redirectToHealthBoard } from '../../../utils/appointments/redirect-utils';
import AppointmentDetailsPopup from '../../Healthboard/Components/AppointmentDetailsPopup';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';

function AppointmentSummary({ appointment, handleStartVisit }) {
  const onceStarted = useRef(false);
  const userId = get(appointment, 'userId');

  usePageView('Get Care | Summary');

  const onClose = () => {
    if (userId) {
      redirectToHealthBoard(userId);
    }
  };

  useEffect(() => {
    if (appointment && !onceStarted.current) {
      onceStarted.current = true;
      handleStartVisit(appointment);
    }
  }, [appointment]);

  return (
    appointment && (
      <AppointmentDetailsPopup
        opened
        userId={userId}
        appointment={appointment}
        onStartVideoVisit={handleStartVisit}
        onClose={onClose}
      />
    )
  );
}

AppointmentSummary.propTypes = {
  appointment: PropTypes.object,
  handleStartVisit: PropTypes.func,
};

export default enhance(AppointmentSummary);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentSummary/index.jsx